var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-circle",style:({ background: _vm.colour || _vm.emptyColour,
       border: _vm.isError ? '1px solid #b30000' : '1px solid rgb(118, 118, 118)'})})}
var staticRenderFns = []

export { render, staticRenderFns }